import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navigation from './components/Navigation.jsx';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import Reviews from './pages/Reviews';
import About from './pages/About';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import PhysicalTherapy from './pages/PhysicalTherapy';
import OccupationalTherapy from './pages/OccupationalTherapy';
import SpeechTherapy from './pages/SpeechTherapy';
import SocialServices from './pages/SocialServices';
import CertifiedHomeHealthAid from './pages/CertifiedHomeHealthAid';
import AlzheimersCare from './pages/AlzheimersCare';
import GeriatricCareManagement from './pages/GeriatricCareManagement';
import MedicationReminders from './pages/MedicationReminders';
import PostHospitalizationCare from './pages/PostHospitalizationCare';
import LearnMore from './pages/LearnMore';
import Search from './pages/Search';
import Counties from './pages/Counties';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="*" element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/learn-more" element={<LearnMore />} />
          <Route path="/search" element={<Search />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/skilled-nursing" element={<ServiceDetail />} />
          <Route path="/services/physical-therapy" element={<PhysicalTherapy />} />
          <Route path="/services/occupational-therapy" element={<OccupationalTherapy />} />
          <Route path="/services/speech-therapy" element={<SpeechTherapy />} />
          <Route path="/services/social-services" element={<SocialServices />} />
          <Route path="/services/certified-home-health-aid" element={<CertifiedHomeHealthAid />} />
          <Route path="/services/alzheimers-care" element={<AlzheimersCare />} />
          <Route path="/services/geriatric-care-management" element={<GeriatricCareManagement />} />
          <Route path="/services/medication-reminders" element={<MedicationReminders />} />
          <Route path="/services/post-hospitalization-care" element={<PostHospitalizationCare />} />
          <Route path="/counties" element={<Counties />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
